import { t } from '!/i18n'
import { type EpgInfo } from '@setplex/tria-api'
import { isToday, isTomorrow } from 'date-fns'
import {
  DATE_FORMATS,
  formatDateToLabelInfo,
  formatStartTime,
} from '~/shared/helpers/date'
import { type ProgramEpgInfo } from '../index.h'

/**
 * key for upcoming programs map
 */
export const getMapKeyForProgram = ({
  epgId,
  title,
  startMs,
}: Pick<EpgInfo, 'epgId' | 'title' | 'startMs'>): string =>
  `${epgId}|${title}|${startMs}`

export const getFormattedSubtitle = (episode?: string, subtitle?: string) => {
  return episode && subtitle ? `${episode}: ${subtitle}` : subtitle || episode
}

export const getProgramStartDay = (start: string) => {
  const startDate = new Date(start)
  if (isToday(startDate)) return t('today')
  if (isTomorrow(startDate)) return t('tomorrow')
  return formatStartTime(startDate, DATE_FORMATS.DD_MMM)
}

export const formatProgram = (program: Readonly<EpgInfo>): ProgramEpgInfo => {
  const start = new Date(program.actualStartMs).toString()
  const stop = new Date(program.actualStopMs).toString()
  return {
    title: program.title,
    subtitle: getFormattedSubtitle(program.episode, program.subtitle),
    episode: program.episode,
    date: program.date,
    actors: program.actors,
    directors: program.directors,
    categories: program.categories,
    start,
    stop,
    description: program.description,
    icon: program.icon,
    rating: program.rating,
    labels: [
      getProgramStartDay(start),
      formatDateToLabelInfo(program.actualStartMs, program.actualStopMs),
    ],
  }
}
